(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('system-amended-trades', {
            parent: 'entity',
            params:{screen: 'SystemAmendedTradesReport'},
            url: '/system-amended-trades',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.systemAmendedTrades.main" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/system-amended-trades/system-amended-trades.html',
                    controller: 'SystemAmendedTradesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('systemAmendedTrades');                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                systemSettings: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }]
               
            }
        })
    };
})();
